fp.ui.ListManager = fp.ListManager.extend({
    construct: function (options) {
        var self = this;
        this.events = [{
            name: fp.events.LIST_CREATE,
            value: function(event, payload){
                if(
                    payload.listManager.type !== 'list' ||
                    event.handled
                ) {
                    return;
                }
                event.handled = true;
                self.listCreate(event, payload.name);
            }
        }, {
            name: fp.events.LIST_DELETE,
            value: function(event, payload){
                if(
                    payload.listManager.type !== 'list' ||
                    event.handled
                ) {
                    return;
                }
                event.handled = true;
                self.listDelete(event, payload.id);
            }
        }, {
            name: fp.events.LIST_ACTIVATE,
            value: function(event, payload){
                if(
                    payload.listManager.type !== 'list' ||
                    event.handled
                ) {
                    return;
                }
                event.handled = true;
                self.listActivate(event, payload.id);
            }
        }, {
            name: fp.events.LIST_RENAME,
            value: function(event, payload){
                if(
                    payload.listManager.type !== 'list' ||
                    payload.listManager.getList().id != self.getList().id ||
                    event.handled
                ) {
                    return;
                }
                event.handled = true;
                self.listRename(event, payload.id, payload.name);
            }
        }, {
            name: fp.events.LIST_RENAMED,
            value: function(event, payload){
                if(payload.listManager.type !== 'list') return;
                self.listUpdate(payload.list);
            }
        }, {
            name: fp.events.LIST_CHECK_TOGGLE,
            value: function(event, payload){
                if(
                    payload.listManager.type !== 'list' ||
                    payload.listManager.getList().id != self.getList().id ||
                    event.handled
                ) {
                    return;
                }
                event.handled = true;
                self.listToggleChecked(event);
            }
        }, {
            name: fp.events.LIST_CHECKOUT,
            value: function(event, payload){
                if(
                    payload.listManager.type !== 'list' ||
                    event.handled
                ) {
                    return;
                }
                event.handled = true;
                self.listCheckout(event, payload);
            }
        }, {
            name: fp.events.LIST_ITEMS_CLEAR,
            value: function(event, payload){
                if(
                    payload.listManager.type !== 'list' ||
                    payload.listManager.getList().id != self.getList().id ||
                    event.handled
                ) {
                    return;
                }
                event.handled = true;
                self.listItemsClear(event);
            }
        }, {
            name: fp.events.STORE_CHANGED,
            value: function(event, payload) {
                if(
                    fpConfig.disableInitializeShopping ||
                    (!fp.loaded && fp.__$shopIntentModal) ||
                    (!fp.loaded && self.selectedList.__loaded && S(fp.__oldStoreId).eq(payload?.id))
                ) {
                    return;
                }

                fpUtil.cache.remove('oneClickCheckout');

                if(self.options.limit !== 1) self.refreshLists();
                else self.refreshList(true);
            }
        }];

        this._super(options);

        _.defaults(options, {
            enableOneClick: false
        });
    },
    setSelectedList: function(list) {
        const oldList = this.selectedList;

        this._super(list);

        if (oldList?.id == list?.id && _.has(oldList, 'oneClickCheckout')) {
            list.oneClickCheckout = oldList.oneClickCheckout;
        }

        if(fpUtil.isAuthenticated() && this.selectedList.id !== fp.defaultList.id && !fp.getSessionCookie().active_list_id) {
            fp.setSessionCookie({active_list_id: this.selectedList.id});
        }
    },
    setEnableCheckout: function() {
        this.selectedList.enableCheckout = fpUtil.getBoolean(fp.ui.ListManager.getListQuantity(this.selectedList) && fp.hasStoreFulfillment());
    },
    refreshList: function(refreshItems, payload, options) {
        //no need to make API call for bots
        if(fp.isBot) {
            return $.when();
        }

        const sessionCookie = fp.getSessionCookie();
        payload = _.getObject(payload);
        options = _.defaults(options, this.options);

        if(payload.id && payload.id != sessionCookie.active_list_id) {
            return this.listActivate(null, payload.id);
        }

        if(refreshItems) payload.include_items = refreshItems;
        if(fp.config.reward) payload.show_expected_rewards = true;

        // payload.hang_for = options.hang_for;

        if(!payload.id) {
            if (this.selectedList.id === fp.defaultList.id && sessionCookie.active_list_id) {
                payload.id = sessionCookie.active_list_id;
            }
            else if (this.selectedList.id !== fp.defaultList.id) {
                payload.id = this.selectedList.id;
            }
        }

        if(!payload.id) {
            payload = _.defaults(payload, {
                sort: 'updated_at!,created_at!',
                limit: 1
            });
        }

        let self = this,
            deferred = $.Deferred(),
            listResp;

        fpService.shoppingListService
            .get(this.applyPayloadOrderParams(payload, {enableOrderMinimum: true}), options)
            .done(function(resp) {
                listResp = resp;
            })
            .always(function() {
                let list = listResp;

                if(_.has(list, 'total')) {
                    list = _.first(list.items);
                }

                const oldList = _.getObject(self.selectedList),
                    items = list?.items;
                self.setSelectedList(list);
                list = self.selectedList;

                //setSelectedList will wipe out list.items so manually set it
                if(refreshItems && oldList.id == list.id) {
                    list.items = _.getArray(items);
                }

                list.__loaded = true;
                self.setEnableCheckout();

                self.initOneClickConfiguration(list, {
                    handleErrors: false,
                    enableOneClick: options.enableOneClick
                })
                .always(function() {
                    self.listUpdate(list);

                    deferred.resolve(list);

                    if(refreshItems) fp.trigger(fp.events.LIST_ITEMS_REFRESHED, {listManager: self, list: list});
                    fp.trigger(fp.events.LIST_LOADED, {listManager: self, list: list});

                    if(self === fp.listManager) {
                        fp.trigger(fp.events.LIST_REFRESHED, {
                            listManager: self,
                            quantityTotal: fp.ui.ListManager.getListQuantity(list),
                            listTotal: list.item_total_display,
                            id: list.id
                        });
                    }
                });
        });

        return deferred.promise();
    },
    applyPayloadOrderParams: function(payload, options) {
        var stateManager = fp.ui.router.stateManager,
            routeStates = fpConfig.routeStates,
            preference = fp.session.preference;
            payload = _.getObject(payload);
            options = _.getObject(options);

        if (options.intent === 'listItemsChange'){
            payload.order_id = preference.order_id;
        }
        // if (stateManager.is(routeStates.checkout)) return payload;
        if (!stateManager.contains(stateManager.current, routeStates.checkout)) return payload;

        if(payload.id) {
            delete payload.sort;
            delete payload.limit;
        }

        if (preference.order_id) {
            payload.order_id = preference.order_id;
            if(preference.order_store_id) payload.store_id = preference.order_store_id;
            if(preference.order_fulfillment_type_id) payload.fulfillment_type_id = preference.order_fulfillment_type_id;
            if(preference.order_fulfillment_slot_id) payload.fulfillment_slot_id = preference.order_fulfillment_slot_id;
            

            if(options.enableOrderMinimum) {
                payload.check_order_minimum = fpUtil.getBoolean(payload.check_order_minimum, true);
            }

            if(options.intent === 'listItems' || options.intent === 'listItemsChange') {
                payload.for_order_id = payload.order_id;
            }
            else {
                const paymentIdentifier = (preference.payment_method === 'saved_payment' && preference.saved_payment_method) || preference.payment_method;
                if(paymentIdentifier) {
                    payload.checkout = paymentIdentifier;
                    payload.is_checkout = true;
                }
                delete payload.sort;
                delete payload.limit;
            }

            // if(preference.payment_method) payload.checkout = preference.payment_method;

            return this._super(payload);
        }

        var fulfillmentTypeId = fpUtil.map.get('fulfillmentType').get(stateManager.current.self.url).id || preference.order_fulfillment_type_id;
        if (fulfillmentTypeId) {
            payload = _.getObject(payload);
            payload.fulfillment_type_id = fulfillmentTypeId;

            if (options.enableOrderMinimum) {
                payload.check_order_minimum = fpUtil.getBoolean(payload.check_order_minimum, true);
            }
        }

        return this._super(payload);
    },
    refreshLists: function(id) {
        const self = this;
        let payload,
            promise;

        if(!id) {
            payload = {
                sort: 'updated_at!,created_at!',
                limit: -1
            };
        }

        //no need to make API call for bots
        if(!fp.isBot) {
            promise = fpService.shoppingListService
                .get(this.applyPayloadOrderParams(payload, {
                        enableOrderMinimum: true
                }));
        }

        return $.when(promise)
            .then(function(resp) {
                self.lists = _.getArray(resp?.items);

                let list,
                    promise;

                if(!id && self.selectedList) list = self.selectedList;
                
                if(!list && id) {
                    if(self !== fp.listManager && id === fp.listManager.selectedList.id) {
                        list = self.listUpdate(fp.listManager.selectedList);
                    }
                    if(!list) list = _.findWhere(self.lists, {id: id});
                }
                if(!list && fpUtil.isAuthenticated()) {
                    list = self.lists[0];
                }

                self.setSelectedList(list);

                if(!(!fp.loaded && self.selectedList.__loaded)) {
                    //refresh active list in order to get estimated total
                    promise = self.refreshList(true);
                }
                else {
                    promise = self.initOneClickConfiguration(self.selectedList, {
                        handleErrors: false
                    });
                }

                return promise;
            });
    },
    listCreate: function(event, name) {
        name = $.trim(name);
        if(!name) return;

        var self = this;
        return fpService.shoppingListService
            .create({name: name})
            .then(function(resp) {
                fp.setSessionCookie({active_list_id: resp.id});

                self.selectedList = $.extend({}, fp.defaultList);
                return self.getSelectedList(true)
                    .done(function() {
                        fp.trigger(fp.events.LIST_CREATED, {listManager: self, list: resp});
                        fp.trigger(fp.events.LIST_ACTIVATED, {listManager: self});
                    });
            });
    },
    listDelete: function(event, id) {
        if(fpUtil.isNewItem(id)) return;
        var self = this;

        return fpService.shoppingListService
            .post({id: id}, {childServiceCall: 'delete'})
            .done(function() {
                _.removeWhere(self.lists, {id: id});

                if(self.selectedList.id == fp.getSessionCookie().active_list_id) {
                    fp.setSessionCookie({active_list_id: null})
                }

                if(self.selectedList.id == id) {
                    self.selectedList = $.extend({}, fp.defaultList);
                    self.getSelectedList(true).done(function() {
                        fp.trigger(fp.events.LIST_DELETED, {listManager: self});
                    });
                }
                else fp.trigger(fp.events.LIST_DELETED, {listManager: self});
            });
    },
    listRename: function(event, id, name) {
        name = $.trim(name);
        if(!name || fpUtil.isNewItem(id)) return;
        var self = this;

        return fpService.shoppingListService
            .update({
                id: id,
                name: name,
                include_items: true
            })
            .done(function(resp) {
                fp.trigger(fp.events.LIST_RENAMED, {
                    listManager: self,
                    id: id,
                    name: name,
                    list: resp
                });
            });
    },
    listUpdate: function(list) {
        if(list) {
            var index = _.findIndex(this.lists, {id: list.id});
            if(index >= 0) {
                this.lists[index] = list;
                if (this.selectedList.id == list.id) this.selectedList = list;
            }
            else list = null;
        }
        return list;
    },
    listActivate: function(event, id, disableTouch) {
        if(fpUtil.isNewItem(id) || this.selectedList.id == id) return $.when();

        fp.setSessionCookie({active_list_id: id});
        this.selectedList = $.extend({}, fp.defaultList);

        var self = this,
            promise;

        if(!disableTouch) {
            promise = fpService.shoppingListService.post(id, {childServiceCall: 'touch'});
        }

        return $.when(promise)
            .then(function() {
                return self.refreshList(true)
                    .done(function() {
                        fp.trigger(fp.events.LIST_ACTIVATED, {listManager: self});
                    });
            });
    },
    listToggleChecked: function(event) {
        var self = this,
            list = this.getList(),
            origIsCrossed = list.total_uncrossed_item_quantity == 0,
            isCrossed = !origIsCrossed,
            label = origIsCrossed ? 'Uncheck All' : 'Check All';
        if(!event.deferredModal) {
            event.deferredModal = $.Deferred();
            fp.trigger(fp.events.CONFIRM_MODAL_SHOW, {
                title: label + ' Confirmation',
                content: 'Do you want to ' + label.toLowerCase() + ' of the items in your list?',
                confirmButtonLabel: 'Yes',
                cancelButtonLabel: 'No',
                callback: event.deferredModal.resolve
            });
        }

        event.deferredModal.done(function(confirm) {
            if(!event.handled) return;
            // event.handled = true;

            if(confirm) {
                for(var n=0;n<list.items.length;n++) {
                    list.items[n].is_crossed = isCrossed;
                }
            }

            fp.trigger(fp.events.LIST_CHECK_TOGGLED, {listManager: self, confirm: confirm});

            if(!confirm) return;
            if(fpUtil.isNewItem(list.id)) return;

            fpService.shoppingListService
                .update({
                    id: list.id,
                    is_crossed: isCrossed
                })
                .done(function() {
                    self.refreshList(true);
                })
                .fail(function() {
                    for(var n=0;n<list.items.length;n++) {
                        list.items[n].is_crossed = isCrossed;
                    }
                });
        });
    },
    listItemsClear: function(event) {
        if(fpUtil.isNewItem(this.selectedList.id)) return;

        var self = this,
            list = this.selectedList;

        if(!event.deferredModal) {
            event.deferredModal = $.Deferred();
            fp.trigger(fp.events.CONFIRM_MODAL_SHOW, {
                title: fp.ui.locale('list-manager-clear-confirmation', 'Clear List Confirmation'),
                content: fp.ui.locale('list-manager-remove-all', 'Do you want to remove all of the items from your list?'),
                confirmButtonLabel: fp.ui.locale('shared-yes', 'Yes'),
                cancelButtonLabel: fp.ui.locale('shared-no', 'No'),
                callback: event.deferredModal.resolve
            });
        }

        event.deferredModal.done(function(confirm) {
            if(!confirm) return;

            var clearedItems = $.extend([], self.selectedList.items);

            self.selectedList.items.length = 0;

            if(_.getObject(fpUtil.map.get('spcStoreSetting').get('order_setting').config).delete_and_create_new_shopping_list_when_clearing) {
                self.listDelete(null, list.id)
                    .then(function() {
                        fp.trigger(fp.events.LIST_ITEMS_CLEARED, {
                            listManager: self,
                            list: self.selectedList,
                            clearedItems: clearedItems,
                            listDeleted: true
                        });

                        return self.listCreate(null, list.name);
                    });
            }
            else {
                fpService.shoppingListService
                    .post({id: list.id}, {childServiceCall: 'clear', formatForRestfulId: true})
                    .then(function() {
                        return self.refreshList(true);
                    })
                    .done(function() {
                        fp.trigger(fp.events.LIST_ITEMS_CLEARED, {
                            listManager: self,
                            list: self.selectedList,
                            clearedItems: clearedItems
                        });
                    });
            }
        });
    },
    listCheckout: function(event, payload) {
        if(fpUtil.isNewItem(this.selectedList.id)) return;

        payload = _.getObject(payload);

        var self = this,
            selectedList = _.getObject(payload.selectedList, this.getList()),
            crossedCount = 0,
            deferredContinue;

        if(!payload.disableIsCrossedCheck) {
            var availableStatusId = fpUtil.map.get('productStatus').get('available').id;
            if(!availableStatusId) return;

            var product;
            _.each(selectedList.items, function(item) {
                if(!item.is_crossed) return;

                product = fpUtil.getProduct(item);
                if(product.id && product.status_id != availableStatusId) {
                    return;
                }

                crossedCount++;
            });
        }

        if(crossedCount) {
            deferredContinue = $.Deferred();

            var deferredModalContent = $.Deferred(),
                listModuleConfig = $.extend({}, fpConfig.modules.list);

            fp.ui.showModal({
                name: 'checkout-confirmation',
                className: 'fp-checkout-confirmation-modal',
                size: 'lg',
                title: 'Checkout Confirmation',
                content: deferredModalContent.promise(),
                buttons: [{title: 'Continue', action: 'continue-checkout'}],
                cancelBtn: 'Close'
            })
            .off('click.modal.checkoutConfirmation')
            .on('click.modal.checkoutConfirmation', '[data-action="continue-checkout"]', function(event) {
                event.preventDefault();
                deferredContinue.resolve();
                fp.formLoader.show($(this));
            });

            listModuleConfig.name = 'list';
            listModuleConfig.elementSelector = $('<div></div>').appendTo(fp.__$freshop);
            listModuleConfig.intent = 'modal';
            listModuleConfig.filter = 'is_crossed';

            fp.ui.loadModule(listModuleConfig)
                .then(function (module) {
                    return module.init();
                })
                .always(function() {
                    var $modalContent = $('<div><p>The following items are marked as checked off.</p><p>Please uncheck them if you wish to have them added to your cart at checkout. If you already have these items or do not wish to order them today just click "Continue".</p></div>');
                    $modalContent.append(listModuleConfig.elementSelector);
                    deferredModalContent.resolve($modalContent);
                });
        }

        var stateManager = fp.ui.router.stateManager,
            routeStates = fpConfig.routeStates,
                promiseCheckout = $.when(deferredContinue)
                .then(function() {
                    if(selectedList.id != fp.getSessionCookie().active_list_id) {
                        return self.listActivate(null, selectedList.id);
                    }
                })
                .then(function() {
                    //initialize order session
                    return fp.session.preference.order_id ? $.Deferred().resolve(fp.session) : fp.clearOrderPreference();
                });

        var checkoutState;
        if(payload.fulfillment_type_id) {
            var fulfillmentType = fpUtil.map.get('fulfillmentType').get(payload.fulfillment_type_id);
            if(fulfillmentType.identifier) {
                checkoutState = stateManager.get(fpUtil.formatString('{0}-{1}', routeStates.checkout.name, fulfillmentType.identifier));
            }
        }
        if(!checkoutState) checkoutState = routeStates.checkout;

        if(payload.isOneClick && selectedList.oneClickCheckout) {
            let isRedirectToReview;
            promiseCheckout = self.initOneClickConfiguration(selectedList, {enableOneClick: true, refresh: true})
                .then(function(resp) {
                    var oneClickCheckout = resp;
                    if(!oneClickCheckout) return;

                    var promisePaymentType = fpService.tagService
                        .get(oneClickCheckout.payment.service_provider_id, {ignoreErrors: true})
                        .done(function(resp) {
                            paymentType = _.getObject(resp);
                        }),
                    promiseMap = fpUtil.map.load(fpService.orderStatusService),
                    params = {
                        slot_id: fpUtil.getNullIfEmpty(payload.slot_id)
                    },
                    order = oneClickCheckout.order;

                    if (selectedList.items.length == 1 && selectedList.items[0].product.fulfillment_type_id != order.fulfillment_type_id) {
                        order.fulfillment_type_id = selectedList.items[0].product.fulfillment_type_id;
                    }
                    
                    return $.when(
                        promisePaymentType,
                        promiseMap
                    )
                    .then(function() {
                        //set default other attributes
                        return fpService.serviceProviderConfigurationService
                            .get({
                                service_provider_type: 'order_other_attribute',
                                store_id: order.store_id,
                                fulfillment_type_id: order.fulfillment_type_id
                            }, {ignoreErrors: true})
                            .done(function (resp) {
                                _.each(resp.items, function(item) {
                                    _.each(item.config && item.config.fields, function(field) {
                                        var defaultOption;
                                        _.find(oneClickCheckout.orderOtherAttributes, function(label) {
                                            return _.find(field.options, function(option) {
                                                if(label == option.label) {
                                                    defaultOption = option;
                                                    return true;
                                                }
                                            }) != null;
                                        });
                                        
                                        if(defaultOption) {
                                            order[field.identifier] = defaultOption.value;
                                        }
                                        else if(field.is_required) {
                                            defaultOption = _.find(field.options, function(option) {
                                                return option.is_default || option.default;
                                            });
                                            if(defaultOption) order[field.identifier] = defaultOption.value;
                                        }
                                    });
                                });
                            });
                    })
                    .then(function() {
                        return fpService.orderService.create(order, {ignoreErrors: true});
                    })
                    .then(function(resp) {
                        order = resp;

                        checkoutState = routeStates.checkoutReview;
                        delete params.slot_id;

                        return fpService.preferenceService
                            .update({
                                order_id: order.id,
                                order_step: 2,
                                order_store_id: order.store_id,
                                order_fulfillment_type_id: order.fulfillment_type_id,
                                saved_payment_method: paymentType.identifier,
                                payment_type_id: oneClickCheckout.payment.id
                            }, {one_click_checkout: true}, {session: true, ignoreErrors: true});
                    })
                    .then(function() {
                        if((fpUtil.map.get('spcStoreSetting').get('order_setting').config).enable_one_click_review){
                            isRedirectToReview = true;
                            return;
                        }
                        return fpService.orderService
                            .post({
                                    id: order.id,
                                    payment_method_id: oneClickCheckout.payment.id,
                                    one_click_checkout: true
                                }, {
                                    childServiceCall: fpUtil.formatString('checkout/{0}', paymentType.identifier),
                                    ignoreErrors: true
                                }
                            );
                    })
                    .then(function() {
                        if(isRedirectToReview) return;

                        return fpService.orderService
                            .update({
                                id: order.id,
                                shopping_list_id: order.shopping_list_id,
                                status_id: fpUtil.map.get('orderStatus').get('user_placed').id,
                                one_click_checkout: true,
                                ignoreErrors: true
                            });
                    })
                    .then(function() {
                        if(isRedirectToReview) return;

                        checkoutState = routeStates.checkoutConfirmation;
                        params.id = order.id;

                        return fpService.preferenceService
                            .update({
                                order_id: order.id,
                                order_step: 3
                            }, {one_click_checkout: true}, {session: true, ignoreErrors: true});
                    })
                    .fail(function(jqXHR, textStatus, errorThrown) {
                        params.error = fpUtil.getXhrErrorResponse(jqXHR).error_message;
                    })
                    .then(function(){
                        if(isRedirectToReview) return;

                        return fp.clearOrderPreference();
                    })
                    .always(function() {
                        stateManager.go(checkoutState, params);
                        fp.formLoader.hide();
                    });
                });
        }
        else {
            promiseCheckout = promiseCheckout
                .done(function() {
                    if(!payload.isInit && stateManager.is(routeStates.checkout)) {
                        fp.trigger(fp.events.CHECKOUT_INIT);
                        return;
                    }

                    if(payload.checkoutUrl) {
                        stateManager.go(payload.checkoutUrl, null, {absolute: true});
                        return;
                    }

                    // var checkoutState;
                    // if(payload.fulfillment_type_id) {
                    //     var fulfillmentType = fpUtil.map.get('fulfillmentType').get(payload.fulfillment_type_id);
                    //     if(fulfillmentType.identifier) {
                    //         checkoutState = stateManager.get(fpUtil.formatString('{0}-{1}', routeStates.checkout.name, fulfillmentType.identifier));
                    //     }
                    // }
                    // if(!checkoutState) checkoutState = routeStates.checkout;

                    stateManager.go(checkoutState, {slot_id: fpUtil.getNullIfEmpty(payload.slot_id)});
                });
        }

        return promiseCheckout
            .fail(function() {
                fp.formLoader.hide();
            });
    },
    getItemWithVariety: function(id, varieties) {
        if(!id) return;
        if(fpUtil.isNewItem(id)) return;

        id = id.toString();

        return _.find(this.selectedList.items, function(item) {
            return item.id == id && _.isEqual(item.varieties, varieties);
        });
    },
    initOneClickConfiguration: function (list, options) {
        options = _.getObject(options);

        let promiseOneClickCheckout;

        if (
            !fpConfig.disableOneClick &&
            (this.options.enableOneClick || options.enableOneClick) &&
            fpUtil.isAuthenticated() &&
            fp.ui.ListManager.getListQuantity(list)
        ) {
            let handleErrors = options.handleErrors,
                cacheKey = 'oneClickCheckout',
                cachedOneClickCheckout = options.refresh ? null : fpUtil.cache.get(cacheKey),
                oneClickCheckout,
                savedPayment,
                order,
                orderOtherAttributes;

            if(_.size(cachedOneClickCheckout)) {
                savedPayment = $.extend(true, {}, cachedOneClickCheckout.payment);
                order = $.extend(true, {}, cachedOneClickCheckout.order);
                orderOtherAttributes = $.extend(true, {}, cachedOneClickCheckout.orderOtherAttributes);
                if(order.shopping_list_id) order.shopping_list_id = list.id;
            }

            const fulfillmentTypes = fp.getStoreFulfillmentTypes(),
                preferredFulfillmentType = fp.user.preferred_fulfillment_type_id && _.findWhere(fulfillmentTypes, {id: fp.user.preferred_fulfillment_type_id});

            if(
                !_.size(cachedOneClickCheckout) &&
                preferredFulfillmentType &&
                fp.store['allow_order_change_by_customer_' + preferredFulfillmentType.identifier]
            ) {
                let promiseUserAddress,
                    multiplexId = _.uniqueId(),
                    userAddress,
                    pastOrder = {},
                    promisePayment = fpService.userMeService
                        .get({
                            limit: 1,
                            store_id: fp.store.id,
                            update_at_sort: 'desc'
                        }, {
                            childServiceCall: 'payment_methods',
                            handleErrors: handleErrors,
                            multiplexId: multiplexId
                        })
                        .then(function (resp) {
                            savedPayment = _.first(resp.items);
                        }),
                    promiseOrder = fpService.orderService
                        .get({
                            limit: 1,
                            intent: 'past_orders',
                            fulfillment_type_id: preferredFulfillmentType.id,
                            sort: 'created_at!'
                        }, {
                            handleErrors: handleErrors,
                            multiplexId: multiplexId
                        })
                        .then(function (resp) {
                            pastOrder = _.firstObject(resp.items);
                        });

                if(_.contains(['delivery', 'drop_ship'], preferredFulfillmentType.identifier)) {
                    promiseUserAddress = fpService.userAddressService
                        .get({
                            is_default_for_delivery: true
                        }, {
                            handleErrors: handleErrors,
                            multiplexId: multiplexId
                        })
                        .then(function (resp) {
                            userAddress = _.firstObject(resp.items);
                        });
                }

                promiseOneClickCheckout = $.when(promiseOrder, promiseUserAddress, promisePayment)
                    .then(function() {
                        if(savedPayment && pastOrder && !(userAddress || fp.user.address)) {
                            promiseOneClickCheckout = promiseOneClickCheckout
                                .then(fpService.userMeService.applyAddress);
                        }
                    })
                    .then(function() {
                        if(savedPayment && pastOrder) {
                            userAddress = _.getObject(userAddress || fp.user.address);

                            order = {
                                store_id: fp.store.id,
                                fulfillment_type_id: preferredFulfillmentType.id,
                                shopping_list_id: list.id,
                                fulfillment_name: fp.user.display_name,
                                fulfillment_email: fp.user.email,
                                fulfillment_phone: userAddress.phone || pastOrder.fulfillment_phone,
                                bagging_type_id: pastOrder.bagging_type_id,
                                one_click_checkout: true
                            };

                            orderOtherAttributes = pastOrder.other_attributes;

                            if (_.contains(['delivery', 'drop_ship'], preferredFulfillmentType.identifier)) {
                                _.each([
                                    'address_1',
                                    'address_2',
                                    'city',
                                    'state',
                                    'postal_code',
                                    'country'
                                ], function(key) {
                                    var field = 'fulfillment_' + key;
                                    order[field] = userAddress[key] || pastOrder[field];
                                });

                                if (fpConfig.enablePhoneCountryCode && userAddress.phone_country) {
                                    order.fulfillment_phone_country = userAddress.phone_country;
                                }

                                if(
                                    !order.fulfillment_country &&
                                    preferredFulfillmentType.config &&
                                    preferredFulfillmentType.config.no_international_deliveries
                                ) {
                                    order.fulfillment_country = 'United States';
                                }
                            }
                        }
                    });

                fpService.multiplexService.run(multiplexId);
            }

            if(preferredFulfillmentType) {
                promiseOneClickCheckout = $.when(promiseOneClickCheckout)
                    .then(function() {
                        if(_.size(savedPayment) && _.size(order)) {
                            const payload = {
                                for_shopping_list_id: list.id,
                                store_id: fp.store.id,
                                fulfillment_type_id: preferredFulfillmentType.id,
                                is_available: true,
                                fields: 'id,sequence,fulfillment_type_id,location_id,location,date,time,slot_start,slot_end,booking_close_minutes_prior,additional_fee',
                                sort: 'date',
                                limit: 1
                            };

                            if (_.contains(['delivery', 'drop_ship'], preferredFulfillmentType.identifier)) {
                                _.each([
                                    'address_1',
                                    'city',
                                    'state',
                                    'postal_code',
                                    'country'
                                ], function(key) {
                                    var field = 'fulfillment_' + key;
                                    payload[field] = order[field];
                                });
                            }

                            return fpService.storeSlotService.get(payload, {handleErrors: handleErrors})
                                .then(function (resp) {
                                    const availableSlot = _.first(resp?.items);
                                    if(_.size(availableSlot)) {
                                        order.fulfillment_slot_id = availableSlot.id;

                                        let slotDateLabel = fp.ui.getFulfillmentSlotDateTimeLabel(availableSlot);
                                        slotLabel = dateFns.isToday(slotDateLabel.date) ?
                                            fpUtil.formatString('Today {0} {1}', fpUtil.getStateValue(S(preferredFulfillmentType.name).eq('pick up', true), 'at', 'between'), slotDateLabel.timeLabel) :
                                            slotDateLabel.label;

                                        return {
                                            payment: savedPayment,
                                            slotLabel: slotLabel,
                                            order: order,
                                            orderOtherAttributes: orderOtherAttributes
                                        };
                                    }
                                });
                        }
                    });
            }
    
            promiseOneClickCheckout = $.when(promiseOneClickCheckout)
                .done(function(resp) {
                    oneClickCheckout = resp;
                })
                .always(function() {
                    if(_.size(oneClickCheckout)) {
                        list.oneClickCheckout = oneClickCheckout;
                        fpUtil.cache.set(cacheKey, $.extend(true, {}, oneClickCheckout), 3000);
                    }
                    else {
                        delete list.oneClickCheckout;
                        fpUtil.cache.remove(cacheKey);
                    }
                });
        }

        return $.when(promiseOneClickCheckout);
    }
});

$.extend(fp.ui.ListManager, {
    getItemQuantity: function (item, ignoreNotAvailable, forQuantityIndicator, ignoreCrossed) {
        if (!_.isObject(item)) return 0;
        if (!ignoreCrossed && item.is_crossed && fp.store.allow_shopping_list_crossing) return 0;
    
        ignoreNotAvailable = fpUtil.getBoolean(ignoreNotAvailable, true);
        forQuantityIndicator = fpUtil.getBoolean(forQuantityIndicator, false);
    
        var quantity = item.quantity || 0;
    
        if (forQuantityIndicator) quantity = item.quantity_indicator || quantity;
    
        if (quantity && !ignoreNotAvailable && fp.store.id) {
            if (fpUtil.map.get('productStatus').get(fpUtil.getProduct(item).status_id).identifier != 'available') quantity = 0;
        }
    
        return quantity;
    },
    getItemQuantityTotal: function (options) {
        options = _.getObject(options);
        if (!_.isObject(options.item)) return 0;
    
        var item = options.item,
            ignoreNotAvailable = options.ignoreNotAvailable,
            forQuantityIndicator = options.forQuantityIndicator,
            ignoreCrossed = options.ignoreCrossed,
            listManager = _.getObject(options.listManager, fp.listManager),
            product = fpUtil.getProduct(options.item);
    
        if (!_.size(product.varieties)) {
            return this.getItemQuantity(item, ignoreNotAvailable, forQuantityIndicator, ignoreCrossed);
        }
    
        var quantity = 0,
            getItemQuantity = fp.ui.ListManager.getItemQuantity;
        _.each(listManager.getItem(product.id, {isProductId: true, multiple: true}), function (listItem) {
            quantity += getItemQuantity(listItem, ignoreNotAvailable, forQuantityIndicator, ignoreCrossed);
        });
    
        return quantity;
    },
    getListQuantity: function (list) {
        if (!_.isObject(list)) {
            if (!fp.listManager) return 0;
            list = fp.listManager.getList();
        }
    
        return fpUtil.getInteger(list.total_checkout_item_quantity);
    },
    getIncrement: function (item) {
        return fpUtil.getProduct(item).quantity_step || fpConfig.productIncrement;
    },
    getQuantityInitial: function (item) {
        var product = fpUtil.getProduct(item);
        return product.quantity_initial != null ? product.quantity_initial : fpConfig.productIncrement;
    },
    getItemVariety: function (item, options) {
        let itemVarietyConfig,
            itemVarieties;
        if(fpUtil.isOrderItem(item)) {
            itemVarietyConfig = item.ordered_varieties_config;
            itemVarieties = item.ordered_varieties;
        }
        if(item?.product && !itemVarietyConfig && !itemVarieties) {
            itemVarietyConfig = item.product.varieties;
            itemVarieties = item.product_varieties || item.varieties;
        }

        if (!(_.size(itemVarietyConfig) && _.size(itemVarieties))) return '';

        if (!_.isObject(options)) options = {asList: options};
    
        let varieties = '',
            variety,
            option,
            varietyLabel,
            price,
            hasPrice;
 
        if(fp.config.enableKiosk){
            varieties += fpUtil.formatString(' \
                    <li> \
                        <span class="fp-product-variety-label"><strong>{0}</strong>: {1}</span> \
                        ' + '<span class="fp-product-variety-price">{2}</span>' + ' \
                    </li> \
                ', 'Quantity', item.quantity, item.item_total);
        }

        _.each(itemVarieties, function (value, key) {
            variety = _.findWhere(itemVarietyConfig, {identifier: key});
            if (!variety) return;
    
            option = _.findWhere(variety.options, {value: value});
            if (!option) return;

            if(!options.disablePrice) {
                price = fp.numeralInstance.set(option.price).value();
                if (price) hasPrice = true;
            }
    
            if (options.asList) {
                if (fp.config.enableKiosk) {
                    varieties += fpUtil.formatString(' \
                            <li> \
                                <span class="fp-product-variety-label"><strong>{0}</strong>: {1}</span> \
                                ' + fpUtil.getStateValue(price, '<span class="fp-product-variety-price">{2}</span>', '<span class="fp-product-variety-price">$0.00</span>') + ' \
                            </li> \
                        ', variety.label, option.label, option.price_offset || option.price);
                }
                else {
                    varieties += fpUtil.formatString(' \
                            <li> \
                                <span class="fp-product-variety-label">{0}: {1}</span> \
                                ' + fpUtil.getStateValue(price, '<span class="fp-product-variety-price">{2}</span>', '') + ' \
                            </li> \
                        ', variety.label, option.label, option.price_offset || option.price);
                }
                    
                var otherAttributes = item.other_attributes && item.other_attributes[variety.identifier],
                    attributeValues = '',
                    attributeValue;
                if(_.size(otherAttributes) && option.other_attributes) {
                    _.each(option.other_attributes.attributes, function(attribute) {
                        if(attributeValue = otherAttributes[attribute.value]) {
                            // varieties += fpUtil.formatString(' \
                            //     <li> \
                            //         <span class="fp-product-variety-label">{0}: {1}</span> \
                            //     </li> \
                            // ', attribute.label, attributeValue);
                            if(attributeValues) attributeValues += ', ';
                            attributeValues += fpUtil.formatString(' {0}: {1}', attribute.label, attributeValue);
                        }
                    });
                }
                if(attributeValues) {
                    varieties += fpUtil.formatString('<li class="fp-font-size-sm">{0}</li>', attributeValues);
                }
            }
            else {
                varietyLabel = option.label;
                if (price) varietyLabel += ' (' + (option.price_offset || option.price) + ')';
                if (varieties) varieties += ', ';
    
                if (options.prefix) varietyLabel = options.prefix + varietyLabel;
                if (options.suffix) varietyLabel += options.suffix;
    
                varieties += variety.label + ': ' + varietyLabel;
            }
        });
    
        return options.asList ? fpUtil.formatString('<ul class="fp-product-variety-sub-list {0}">{1}</ul>', fpUtil.getStateValue(hasPrice, 'fp-has-product-variety-price', ''), varieties) : varieties;
    },
    getItemVarieties: function (item) {
        var varieties = [];
    
        if (!_.isObject(item)) return varieties;
        if (!_.isObject(item.product)) return varieties;
    
        var productVarieties = item.product.varieties;
        if (!_.size(productVarieties)) return varieties;
    
        var variety,
            option;
    
        _.each(item.varieties, function (value, key) {
            variety = _.findWhere(productVarieties, {identifier: key});
            if (!variety) return;
    
            option = _.findWhere(variety.options, {value: value});
            if (!option) return;
    
            varieties.push({
                varietyLabel: variety.label,
                varietyIdentifier: variety.identifier,
                optionLabel: option.label,
                optionValue: value
            });
        });
    
        return varieties;
    },
    setListDefaults: function(list) {
        if(!_.isObject(list)) return;
        var defaultTotal = fp.config.defaultCurrencyFormat ? fp.config.defaultCurrencyFormat : fp.numeralInstance.set(0).format(fp.config.currencyFormat);
        list.item_total = list.item_total || defaultTotal;
        list.item_total_display = list.item_total;
        list.order_total = list.order_total || defaultTotal;
        //list.total_uncrossed_item_quantity = list.total_uncrossed_item_quantity || 0;
        list.total_crossed_item_quantity = list.total_crossed_item_quantity || 0;
        list.items = _.getArray(list.items);
    },
    getListItemQuantityAsInt: function(item) {
        let quantity = 0;
        if(_.isObject(item) && item.quantity) {
            const product = fpUtil.getProduct(item);
            if (product.is_weight_required && fpUtil.isFloat(product.quantity_step)) {
                quantity = 1;
            }
            else {
                quantity = fpUtil.getInteger(item.quantity);
            }
        }
        return quantity;
    }
});